<template>
    <a-select
            v-model="model"
            :placeholder="placeholder"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            @change="handleChange"
            @select="onSelect"
            :notFoundContent="null"
    >
        <a-select-option v-for="(option,index) in options" :key="option.id"  :value="option" >{{option.name}}({{option.num}}) {{option.sex|sex}}</a-select-option>
    </a-select>
</template>
<script>
    export default {
    name: 'SubjectJiaolianPicker',
    data () {
      return {
        model:undefined,
      }
    },
    props: {
        placeholder:{
            type: String,
            default:'请选择教练员'
        },
        options:{
            type: Array,
            default:[]
        }
    },
    computed:{
    },
        filters:{
        sex(val){
            if(val == 1){
                return '男'
            }else if(val==2){
                return '女'
            }else{
                return '未知'
            }
        }

        },
      watch: {
      },
      created(){
      },
    methods: {
        handleChange(value){
//            this.formData[this.field] = value;
            console.log('picker- handleChange',value);
            this.$emit("onChange", value);
       },
        onSelect(value,option){
//            this.formData[this.field] = value;
            console.log('picker- onSelect',value);
            this.$emit("onSelect", value);
       }
    },
  }
</script>
<style>

</style>